import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { MapPin, UserSquare2, CalendarClock, Eye, TrendingUp, RotateCcw } from "lucide-react";
import { STATUS_CATS, isApprox, fmtDataBR } from "./mapaUtils";

export default function MapaPopup({ item, status, onOpen, canEdit, onReset }) {
  const cat = STATUS_CATS.find((s) => s.key === status);
  return (
    <div className="min-w-[220px] space-y-2 text-[12px]" data-testid={`mapa-popup-${item.id}`}>
      <div className="font-semibold text-sm leading-tight">{item.condominio}</div>
      <div className="flex flex-wrap gap-1">
        <Badge variant="outline" className="capitalize text-[10px]">{item.tipo || "residencial"}</Badge>
        <Badge variant="outline" className="text-[10px]" style={{ borderColor: cat.color, color: cat.color }}>{cat.label}</Badge>
      </div>
      <div className="flex gap-1.5 text-muted-foreground"><MapPin className="w-3.5 h-3.5 shrink-0 mt-0.5" />{item.endereco}</div>
      <div className="flex gap-1.5"><UserSquare2 className="w-3.5 h-3.5 shrink-0 mt-0.5" />{item.consultor || "Sem consultor"}</div>
      <div className="flex gap-1.5">
        <CalendarClock className="w-3.5 h-3.5 shrink-0 mt-0.5" />
        Última ação: {fmtDataBR(item.ultima_acao)}{item.acoes_30d > 0 ? ` · ${item.acoes_30d} em 30 dias` : ""}
      </div>
      <div className="flex gap-1.5" data-testid={`mapa-popup-vendas-${item.id}`}>
        <TrendingUp className="w-3.5 h-3.5 shrink-0 mt-0.5" />
        {item.clientes_fechados || 0} cliente(s) fechado(s) · {item.vendas_realizadas || 0} venda(s) realizada(s)
      </div>
      {item.precisao === "manual" && (
        <div className="flex items-center justify-between gap-2 text-[10px] text-primary">
          <span>Posição ajustada manualmente.</span>
          {canEdit && (
            <button type="button" onClick={onReset} className="flex items-center gap-1 underline-offset-2 hover:underline" data-testid={`mapa-popup-reset-${item.id}`}>
              <RotateCcw className="w-3 h-3" /> Automática
            </button>
          )}
        </div>
      )}
      {isApprox(item.precisao) && (
        <p className="text-[10px] text-amber-500">
          Localização aproximada (pelo {item.precisao}).{canEdit ? " Use “Ajustar pinos” para corrigir." : ""}
        </p>
      )}
      <Button size="sm" className="w-full h-8" onClick={onOpen} data-testid={`mapa-popup-abrir-${item.id}`}>
        <Eye className="w-3.5 h-3.5 mr-1.5" /> Abrir painel do condomínio
      </Button>
    </div>
  );
}
